
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_1xi3o_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_1xi3o_14",
  "token-field-container": "awsui_token-field-container_vm8qf_1xi3o_18",
  "token-field": "awsui_token-field_vm8qf_1xi3o_18",
  "token-field-disabled": "awsui_token-field-disabled_vm8qf_1xi3o_54",
  "token-field-readonly": "awsui_token-field-readonly_vm8qf_1xi3o_62",
  "token-field-invalid": "awsui_token-field-invalid_vm8qf_1xi3o_68",
  "token-field-warning": "awsui_token-field-warning_vm8qf_1xi3o_80",
  "grouped": "awsui_grouped_vm8qf_1xi3o_92",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vm8qf_1xi3o_102",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vm8qf_1xi3o_106",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vm8qf_1xi3o_112",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vm8qf_1xi3o_116",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vm8qf_1xi3o_120",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vm8qf_1xi3o_126",
  "grouped-with-action": "awsui_grouped-with-action_vm8qf_1xi3o_130",
  "with-error": "awsui_with-error_vm8qf_1xi3o_134",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_vm8qf_1xi3o_162",
  "grouped-vertical-only": "awsui_grouped-vertical-only_vm8qf_1xi3o_162",
  "with-warning": "awsui_with-warning_vm8qf_1xi3o_168",
  "grouped-validation-first": "awsui_grouped-validation-first_vm8qf_1xi3o_210",
  "token-field-icon": "awsui_token-field-icon_vm8qf_1xi3o_214",
  "token-list": "awsui_token-list_vm8qf_1xi3o_220",
  "inline-tokens": "awsui_inline-tokens_vm8qf_1xi3o_234",
  "token-list-item": "awsui_token-list-item_vm8qf_1xi3o_238",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_1xi3o_242",
  "token-overflow": "awsui_token-overflow_vm8qf_1xi3o_249",
  "token-overflow-trigger": "awsui_token-overflow-trigger_vm8qf_1xi3o_253",
  "overflow-dropdown": "awsui_overflow-dropdown_vm8qf_1xi3o_257",
  "overflow-dropdown-item": "awsui_overflow-dropdown-item_vm8qf_1xi3o_266",
  "measurement-container": "awsui_measurement-container_vm8qf_1xi3o_272",
  "measurement-token": "awsui_measurement-token_vm8qf_1xi3o_285"
};
  